<template>
  <div class="box-wrap active-box-wrap" :style="boxWrapStyleObj">
    <span class="border-left-top"></span>
    <span class="border-left-bottom"></span>
    <span class="border-right-top"></span>
    <span class="border-right-bottom"></span>
    <div
      class="statis-title bg1"
      style="display: flex; justify-content: center"
      ref="statisTitle"
    >
      <span>作业统计</span>
      <span class="active-box-more-txt click-element" @click="lookMoreData">
        更多
        <i></i>
      </span>
    </div>
    <div
      class="active-static-tab-content-wrap"
      :style="contentStyleObj"
      style="margin-top: 5px"
    >
      <div class="active-static-tab-content-ranking">
        <p class="active-static-tab-content-ranking-title">排行榜</p>
        <div class="active-static-tab-content-ranking-split-line"></div>
        <ul class="active-static-tab-content-ranking-ul">
          <li
            class="active-static-tab-content-ranking-item click-element"
            v-for="(item, index) in gradeList"
            :title="item.name"
            :key="item.id"
            @click="changeGrade(item.id)"
          >
            <span
              class="active-static-tab-content-ranking-item-num"
              :class="
                item.id == curStaticLocalData.classLv
                  ? 'active-static-tab-content-ranking-item-name-avtive'
                  : ''
              "
              >{{ index + 1 }}</span
            >
            <span
              class="active-static-tab-content-ranking-item-name"
              :class="
                item.id == curStaticLocalData.classLv
                  ? 'active-static-tab-content-ranking-item-name-avtive'
                  : ''
              "
              >{{ item.name }}</span
            >
          </li>
        </ul>
      </div>
      <div class="active-static-tab-content-total">
        <div class="active-static-tab-content-total-num">
          <div class="inter-count">
            <img
              src="../../../assets/images/databoard/inter-cirle-one-small.png"
              width="100%"
              height="100%"
              class="big-img"
            />
            <div class="cirle-small">
              <img
                src="../../../assets/images/databoard/inter-cirle-two-small.png"
                width="100%"
                height="100%"
                class="small-img"
              />
              <div class="count">
                <span class="num">
                  <count-up
                    class="infor-card-count user-created-count"
                    :id-name="'hwNum'"
                    :end-val="curStaticLocalData.hwNum"
                    color="#0EFCFF"
                    countSize="24"
                    :countWeight="countWeight"
                  >
                  </count-up>
                </span>
              </div>
              <div class="active-static-tab-content-total-num-split-line"></div>
              <span class="active-static-tab-content-total-num-unit">份</span>
            </div>
          </div>
        </div>
        <ul class="active-static-tab-content-total-list">
          <li>
            <div class="active-static-tab-content-total-list-item-num">
              {{ curStaticLocalData.hwSubmitRate || 0 }}
            </div>
            <div class="active-static-tab-content-total-list-item-title">
              作业提交率
            </div>
          </li>
          <li>
            <div class="active-static-tab-content-total-list-item-num">
              {{ curStaticLocalData.effective || 0
              }}<span style="font-size: 16px">min</span>
            </div>
            <div class="active-static-tab-content-total-list-item-title">
              有效作业时长
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchHwData } from "../../../service/bigDataApi.js";
import CountUp from "@/components/countUp.vue";
export default {
  name: "cloud-homework-statis",
  components: {
    CountUp,
  },
  data() {
    return {
      gradeId: "",
      // 年级集合
      gradeList: [],
      screenWidth: 0, //屏幕宽度
      boxWrapStyleObj: {
        height: "",
      },
      contentStyleObj: {
        height: "",
      },
      styleObj: {
        width: "100%",
        height: "100%",
      },
      countWeight: 400,
      curStaticLocalData: {}, //当前年级活跃下的统计数据
    };
  },
  props: {
    screenHeight: Number,
    titleHeight: Number,
  },
  watch: {
    screenHeight: "initBoxHeight",
    titleHeight: "initBoxHeight",
  },
  methods: {
    /**
     * 初始化box高度
     */
    initBoxHeight() {
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }
      let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
      let contentHeight =
        boxWrapHeight - this.$refs.statisTitle.offsetHeight - 18;
      this.boxWrapStyleObj.height = boxWrapHeight + "px";
      this.contentStyleObj.height = contentHeight + "px";
    },
    /**
     * 获取作业数据
     */
    async getHwData() {
      let _this = this;
      await fetchHwData()
        .then(function (data) {
          let list = [];
          _this.hwData = data.results.sort(_this.sortBy("hwNum", 1));
          if (_this.hwData.length > 0) {
            for (let i = 0; i < _this.hwData.length; i++) {
              list.push({
                name: _this.hwData[i].chClassLv,
                id: _this.hwData[i].classLv,
              });
            }
            _this.gradeList = list.slice(0, 5);
            _this.gradeId = _this.gradeList[0].id || "";
            _this.hwData[0].hwSubmitRate =
              _this.$utils
                .toDecimal(_this.hwData[0].submitRate * 100)
                .toString() + "%";
            _this.curStaticLocalData = _this.hwData[0];
          }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 根据指定字段 指定排序类型 来排序
     */
    sortBy(name, sortType) {
      return function (o, p) {
        var a, b;
        if (typeof o === "object" && typeof p === "object" && o && p) {
          a = Number(o[name]);
          b = Number(p[name]);
          if (a === b) {
            return 0;
          }
          if (typeof a === typeof b) {
            if (sortType == 1) {
              return a > b ? -1 : 1;
            } else if (sortType == 2) {
              return a < b ? -1 : 1;
            }
          }
          if (sortType == 1) {
            return typeof a > typeof b ? -1 : 1;
          } else if (sortType == 2) {
            return typeof a < typeof b ? -1 : 1;
          }
        } else {
          throw "error";
        }
      };
    },
    /**
     * 选中当前排行榜已选中项
     */
    changeGrade(id) {
      this.gradeId = id;
      this.handleHwDataByGrade();
    },
    /**
     * 根据年级获取作业数据
     */
    handleHwDataByGrade() {
      for (let i = 0; i < this.hwData.length; i++) {
        if (this.hwData[i].classLv == this.gradeId) {
          this.hwData[i].hwSubmitRate =
            this.$utils.toDecimal(this.hwData[i].submitRate * 100).toString() +
            "%";
          this.curStaticLocalData = this.hwData[i];
        }
      }
    },
    /**
     * 查看更多数据信息
     */
    lookMoreData() {
      let href =
        "https://www.17zuoye.com/redirector/login/dc8207ece3b5496a5d62796b443cab199326f6bc5b70896beb7d24d5d6cb3083264b91339860c67027d22ac932b4779a.vpage\n";
      window.open(href, "_blank");
    },
  },
  mounted() {
    this.getHwData();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";
@import "../../../style/layout";
.active-static-tab-content-ranking-split-line {
  background-image: url("../../../assets/images/databoard/active-icon.png");
}

.active-static-tab-content-ranking-item:nth-child(-n + 0) {
  .active-static-tab-content-ranking-item-num {
    color: #0efcff !important;
  }
}

.active-static-tab-content-total-list {
  display: flex;
  justify-content: center;
}

.bg1 {
  background-image: url("../../../assets/images/databoard/title-bg3.png");
}

.active-box-more-txt i {
  background-image: url(../../../assets/images/databoard/active-icon.png);
  background-position: -299px 90px;
}

.active-static-icon-arrow-down {
  background-image: url(../../../assets/images/databoard/active-icon.png);
  background-position: -224px 90px;
}
.active-static-tab-content-ranking-ul {
  overflow: hidden auto !important;
}
</style>

<style lang="scss"></style>
